import RestApi from './api'
import CoolRestApi from './cool-api'
import config from './config'
import fn from './fn'
import routes from './routes'
import stores from './stores'

export default {
  api: {
    RestApi,
    CoolRestApi,
  },
  config,
  fn,
  routes,
  stores,
}
